(function (root) {
  'use strict';
  function limit(value) {
    if (value === undefined || value === null || value === '') return Infinity;
    var number = Number(value);
    return Number.isFinite(number) ? Math.max(0, Math.floor(number)) : Infinity;
  }
  function count(cart, variantId, exceptKey) {
    return (cart.items || []).reduce(function (total, item) {
      return String(item.variant_id || item.id) === String(variantId) && item.key !== exceptKey
        ? total + item.quantity : total;
    }, 0);
  }
  function remaining(limits, cart, variantId, exceptKey) {
    return Math.max(0, limit(limits[String(variantId)]) - count(cart, variantId, exceptKey));
  }
  function problem(limits, cart, updates) {
    var items = cart.items || [], keys = Object.keys(updates), totals = {};
    for (var key of keys) {
      if (!items.some(function (item) { return item.key === key; })) return { type: 'changed' };
      if (!Number.isSafeInteger(updates[key]) || updates[key] < 0) return { type: 'quantity' };
    }
    items.forEach(function (item) {
      var id = String(item.variant_id || item.id);
      var quantity = Object.prototype.hasOwnProperty.call(updates, item.key) ? updates[item.key] : item.quantity;
      totals[id] = (totals[id] || 0) + quantity;
    });
    for (var id of Object.keys(totals)) {
      if (totals[id] > limit(limits[id])) return { type: 'stock', id: id, max: limit(limits[id]) };
    }
    return null;
  }
  function identity(item) {
    var properties = item.properties || {};
    return JSON.stringify([String(item.variant_id || item.id),
      item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id || null,
      Object.keys(properties).sort().map(function (key) { return [key, properties[key]]; })]);
  }
  function findLine(cart, original) {
    return cart.items.find(function (item) { return item.key === original.key; }) ||
      cart.items.find(function (item) { return identity(item) === identity(original); });
  }
  var api = { limit: limit, count: count, remaining: remaining, problem: problem, findLine: findLine };
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.HOCInventory = api;
})(typeof window === 'undefined' ? {} : window);
